module.exports = __webpack_public_path__ + "static/img/product-Business-Analytics-img-768x591.66509b5c.png";